/* eslint-disable no-restricted-globals */
// randev · generador de semillas
// Mismo número, mismo símbolo. Sin dependencias; corre en navegador y en Node.
(function (root, factory) {
  if (typeof module === "object" && module.exports) module.exports = factory();
  else root.RandevSeed = factory();
})(typeof self !== "undefined" ? self : this, function () {
  const INK = "#121316";
  const PAPER = "#ECEDE8";
  const ACCENTS = { cobalto: "#3B54F5", minio: "#E8452C", menta: "#13A37F" };
  const ACCENT_ORDER = ["cobalto", "minio", "menta"];

  function rng(a) {
    return function () {
      a |= 0; a = (a + 0x6d2b79f5) | 0;
      let t = Math.imul(a ^ (a >>> 15), 1 | a);
      t = (t + Math.imul(t ^ (t >>> 7), 61 | t)) ^ t;
      return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
    };
  }

  // Vocabulario: cuarto de círculo (4 giros), círculo, cuadrado, punto, vacío.
  function pick(r) {
    const t = r();
    if (t < 0.52) return "q" + Math.floor(r() * 4);
    if (t < 0.7) return "circle";
    if (t < 0.8) return "square";
    if (t < 0.92) return "dot";
    return "empty";
  }

  // Devuelve la grilla 4x4 y el índice del módulo acento. Reglas de composición:
  // al menos 6 cuartos, máximo 2 vacíos y 2 cuadrados; si no se cumplen, se vuelve a tirar
  // con el mismo generador, así el resultado sigue siendo determinista.
  function layout(seed) {
    const r = rng(seed * 2654435761);
    for (let tries = 0; tries < 50; tries++) {
      const cells = Array.from({ length: 16 }, () => pick(r));
      const count = (k) => cells.filter((c) => c.startsWith(k)).length;
      if (count("q") >= 6 && count("empty") <= 2 && count("square") <= 2) {
        const candidates = cells.map((c, i) => (c === "empty" || c === "dot" ? -1 : i)).filter((i) => i >= 0);
        const accent = candidates[Math.floor(r() * candidates.length)];
        return { cells, accent };
      }
    }
    return { cells: Array(16).fill("q0"), accent: 0 };
  }

  function accentOf(seed) {
    const name = ACCENT_ORDER[seed % 3];
    return { name, hex: ACCENTS[name] };
  }

  function shape(c, x, y) {
    switch (c) {
      case "q0": return `<path d="M${x} ${y}h1A1 1 0 0 1 ${x} ${y + 1}z"/>`;
      case "q1": return `<path d="M${x + 1} ${y}v1A1 1 0 0 1 ${x} ${y}z"/>`;
      case "q2": return `<path d="M${x + 1} ${y + 1}h-1A1 1 0 0 1 ${x + 1} ${y}z"/>`;
      case "q3": return `<path d="M${x} ${y + 1}V${y}A1 1 0 0 1 ${x + 1} ${y + 1}z"/>`;
      case "circle": return `<circle cx="${x + 0.5}" cy="${y + 0.5}" r="0.5"/>`;
      case "square": return `<rect x="${x}" y="${y}" width="1" height="1"/>`;
      case "dot": return `<circle cx="${x + 0.5}" cy="${y + 0.5}" r="0.16"/>`;
      default: return "";
    }
  }

  // opts: { ink, accent (hex o false), background, size, padding (en módulos) }
  function svg(seed, opts = {}) {
    const { cells, accent } = layout(seed);
    const ink = opts.ink || INK;
    const acc = opts.accent === false ? ink : opts.accent || accentOf(seed).hex;
    const pad = opts.padding || 0;
    const vb = 4 + pad * 2;
    const size = opts.size ? ` width="${opts.size}" height="${opts.size}"` : "";
    let out = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="${-pad} ${-pad} ${vb} ${vb}"${size} role="img" aria-label="Semilla #${String(seed).padStart(4, "0")}">`;
    if (opts.background) out += `<rect x="${-pad}" y="${-pad}" width="${vb}" height="${vb}" fill="${opts.background}"/>`;
    out += `<g fill="${ink}" stroke="${ink}" stroke-width="0.012">`;
    cells.forEach((c, i) => { if (i !== accent) out += shape(c, i % 4, Math.floor(i / 4)); });
    out += `</g><g fill="${acc}" stroke="${acc}" stroke-width="0.012">${shape(cells[accent], accent % 4, Math.floor(accent / 4))}</g></svg>`;
    return out;
  }

  const label = (seed) => "#" + String(seed).padStart(4, "0");

  return { svg, layout, accentOf, label, rng, INK, PAPER, ACCENTS };
});
